// removed by extract-text-webpack-plugin
module.exports = {"container":"YzZFM6mXZXlZ9rJQiHHwV","textLabel":"Jbr2Gt-xKVtZg9bUgP3hb","avatar":"_21Fw3LJCAoP2J75RbqiPyg","changeable":"_2mn-RLtnWysq_Ii5HmB0CO _21Fw3LJCAoP2J75RbqiPyg","fileInput":"_2wR9GW7AgMSMEUvuEJWLdE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/style.css
// module id = 281
// module chunks = 0